import React from 'react';

const SecurityIndicators = ({ isFullscreen, cameraPermission, tabSwitchCount }) => {
  return (
    <div className="flex items-center gap-1 text-xs">
      {isFullscreen ? (
        <div className="flex items-center gap-1 bg-green-500 px-1.5 py-0.5 rounded text-xs" title="Fullscreen Active">
          <svg className="h-2.5 w-2.5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
          </svg>
        </div>
      ) : (
        <div className="flex items-center gap-1 bg-red-500 px-1.5 py-0.5 rounded animate-pulse text-xs" title="Fullscreen Inactive">
          <svg className="h-2.5 w-2.5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </div>
      )}
      
      {cameraPermission === 'granted' && (
        <div className="flex items-center gap-1 bg-green-500 px-1.5 py-0.5 rounded text-xs" title="Camera Active">
          <svg className="h-2.5 w-2.5" fill="currentColor" viewBox="0 0 20 20">
            <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
          </svg>
        </div>
      )}
      
      {tabSwitchCount > 0 && (
        <div className={`flex items-center gap-1 px-1.5 py-0.5 rounded font-semibold text-xs ${tabSwitchCount >= 3 ? 'bg-red-600 animate-pulse' : 'bg-yellow-500 text-yellow-900'}`} title={`Tab Switches: ${tabSwitchCount}/5`}>
          <svg className="h-2.5 w-2.5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          <span className="text-xs">{tabSwitchCount}/5</span>
        </div>
      )}
    </div>
  );
};

export default SecurityIndicators;
